
import { createContext, useContext } from 'react';

export interface BuscaProjetosContextType {
  termoBusca: string;
  setTermoBusca: (v: string) => void;
  buscaAberta: boolean;
  setBuscaAberta: (v: boolean) => void;
}

export const BuscaProjetosContext = createContext<BuscaProjetosContextType>({
  termoBusca: '',
  setTermoBusca: () => {},
  buscaAberta: false,
  setBuscaAberta: () => {},
});

export const useBuscaProjetos = () => useContext(BuscaProjetosContext);
